/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyMonitoredObjectGroupSharing
 */
export interface WriteOnlyMonitoredObjectGroupSharing {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObjectGroupSharing
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMonitoredObjectGroupSharing
     */
    monitoredObjectGroup: number;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMonitoredObjectGroupSharing
     */
    receiver: number;
}

export function WriteOnlyMonitoredObjectGroupSharingFromJSON(json: any): WriteOnlyMonitoredObjectGroupSharing {
    return WriteOnlyMonitoredObjectGroupSharingFromJSONTyped(json, false);
}

export function WriteOnlyMonitoredObjectGroupSharingFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyMonitoredObjectGroupSharing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'monitoredObjectGroup': json['monitored_object_group'],
        'receiver': json['receiver'],
    };
}

export function WriteOnlyMonitoredObjectGroupSharingToJSON(value?: WriteOnlyMonitoredObjectGroupSharing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'monitored_object_group': value.monitoredObjectGroup,
        'receiver': value.receiver,
    };
}


